(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_announcement-bar"] && !Shopify.designMode) return;
  try {
    window.AnnouncementBarComponent = function () {
    return {
      init: function () {
        const delay = Number(this.$refs.swiperContainer.dataset.delay || 2000);
        const mobileDelay = Number(this.$refs.swiperContainer.dataset.mobileDelay || 0);
        const slides = this.$refs.swiperContainer.querySelectorAll('.swiper-slide');
        for (let i = 0; i < 2; i++) {
          Array.from(slides).forEach((slide) => {
            this.$refs.swiperWrapper.appendChild(slide.cloneNode(true));
          });
        }

        new Swiper(this.$refs.swiperContainer, {
          breakpoints: {
            1024: {
              slidesPerView: 1,
              spaceBetween: 0,
              speed: 1200,
              autoplay: {
                delay,
                disableOnInteraction: false,
              },
            },
          },
          slidesPerView: 'auto',
          spaceBetween: 150,
          speed: 9000,
          autoplay: {
            delay: mobileDelay,
            disableOnInteraction: false,
          },
          loop: true,
          centeredSlides: true,
          allowTouchMove: false,
        });
      },
    };
  };
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_navigation-submenu"] && !Shopify.designMode) return;
  try {
    window.NavigationSubmenuComponent = function () {
    return {
      open: false,
      hasOpened: false,
      contentInitialized: false,
      hoveredIndex: null,
      resizeHandler: null,
      init: function () {
        this.resizeHandler = () => {
          if (!this.open) return;
          this.fitDesktopSubmenu();
        };
        window.addEventListener('resize', this.resizeHandler);
        document.fonts?.ready.then(() => {
          if (this.open) {
            this.fitDesktopSubmenu();
          }
        });

        this.$watch('open', (value, oldValue) => {
          if (value === oldValue) return;
          if (value) {
            this.hasOpened = true;
            this.$store.settings.enableBodyScrollLock();
            this.$nextTick(() => {
              this.initializeSubmenuContent();
              requestAnimationFrame(() => this.fitDesktopSubmenu());
            });
          } else {
            this.$store.settings.disableBodyScrollLock();
          }
        });
      },
      destroy: function () {
        if (this.resizeHandler) {
          window.removeEventListener('resize', this.resizeHandler);
        }
      },
      initializeSubmenuContent: function () {
        if (this.contentInitialized) return;

        const overlayContainer = this.$refs.overlayContainer;
        const submenuLinks = overlayContainer?.querySelectorAll('.submenu-link-anchor');
        if (!submenuLinks?.length) return;

        submenuLinks.forEach((link, index) => {
          const parentElement = link.parentElement;
          const background = parentElement?.nextElementSibling;

          Motion.hover(link, () => {
            this.hoveredIndex = index;
            const ctaCard = overlayContainer.querySelector('[data-cta-card="true"]');
            if (ctaCard) {
              ctaCard.classList.add('!opacity-0');
            }
            submenuLinks.forEach((submenuLink, submenuLinkIndex) => {
              if (submenuLinkIndex !== index) {
                submenuLink.classList.add('opacity-50');
              }
            });
            if (background) {
              background.classList.remove('opacity-0');
            }

            return () => {
              this.hoveredIndex = null;
              const ctaCard = overlayContainer.querySelector('[data-cta-card="true"]');
              if (ctaCard) {
                ctaCard.classList.remove('!opacity-0');
              }
              submenuLinks.forEach((submenuLink) => {
                submenuLink.classList.remove('opacity-50');
              });
              if (background) {
                background.classList.add('opacity-0');
              }
            };
          });
        });

        this.contentInitialized = true;
      },
      fitDesktopSubmenu: function () {
        if (this.$store.breakpoints.isTablet || this.$store.breakpoints.isMobile) return;

        const list = this.$refs.overlayContainer?.querySelector('[data-submenu-link-list]');
        if (!list) return;

        const defaultFontSizeRem = 2.125;
        const defaultLinkPaddingRem = 0.625;
        const defaultListPaddingRem = 3.75;
        list.style.setProperty('--submenu-link-font-size', `${defaultFontSizeRem}rem`);
        list.style.setProperty('--submenu-link-padding-y', `${defaultLinkPaddingRem}rem`);
        list.style.setProperty('--submenu-list-padding-y', `${defaultListPaddingRem}rem`);

        requestAnimationFrame(() => {
          if (!list.clientHeight || list.scrollHeight <= list.clientHeight) return;

          let scale = (list.clientHeight / list.scrollHeight) * 0.98;
          for (let index = 0; index < 2; index += 1) {
            list.style.setProperty('--submenu-link-font-size', `${defaultFontSizeRem * scale}rem`);
            list.style.setProperty('--submenu-link-padding-y', `${defaultLinkPaddingRem * scale}rem`);
            list.style.setProperty('--submenu-list-padding-y', `${defaultListPaddingRem * scale}rem`);

            if (list.scrollHeight <= list.clientHeight) break;
            scale *= (list.clientHeight / list.scrollHeight) * 0.98;
          }
        });
      },
      onClick: function (label) {
        if (this.$store.breakpoints.isTablet || this.$store.breakpoints.isMobile) {
          this.hasOpened = true;
          this.$nextTick(() => {
            const overlayContent = this.$refs.overlayContent;
            const mobileMenuSecondLevelContent = document.getElementById('mobile-menu-second-level-content');
            const mobileMenuContainer = document.getElementById('mobile-menu-container');
            const mobileMenuSecondLevelLabel = document.getElementById('mobile-menu-second-level-label');
            mobileMenuContainer.dataset.submenuActive = true;
            mobileMenuSecondLevelLabel.innerHTML = label;
            mobileMenuSecondLevelContent.innerHTML = overlayContent.innerHTML;
          });
        } else {
          this.open = !this.open;
        }
      },
      onWindowClick: function (event) {
        if (!this.open) return;
        if (this.$refs.button?.contains(event.target)) return;
        if (this.$refs.overlayContainer?.contains(event.target)) return;
        this.open = false;
      },
    };
  };
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_secondary-navigation"] && !Shopify.designMode) return;
  try {
    window.SecondaryNavigationComponent = function () {
    return {
      mobileOpen: false,
      hasMobileOpened: false,
      init: function () {
        const overlayContainer = this.$refs.overlayContainer;
        const content = this.$refs.content;
        const background = this.$refs.background;
        const mobileMenuButton = document.getElementById('mobile-menu-button');

        mobileMenuButton.addEventListener('click', () => {
          if (!this.mobileOpen) {
            this.hasMobileOpened = true;
          }
          this.mobileOpen = !this.mobileOpen;
          mobileMenuButton.dataset.open = this.mobileOpen;
          const button = mobileMenuButton.querySelector('button');
          button?.setAttribute('aria-label', this.mobileOpen ? button.dataset.closeLabel : button.dataset.openLabel);
        });

        this.$watch('mobileOpen', (value, oldValue) => {
          if (value === oldValue) return;
          if (value) {
            this.$store.settings.enableBodyScrollLock();
          } else {
            this.$store.settings.disableBodyScrollLock();
            // The second-level wrapper applies `pointer-events-auto` via
            // `group-data-[submenu-active=true]/mobile-menu:pointer-events-auto`.
            // That explicit value overrides the inherited `pointer-events:none`
            // from the closed container, so leaving `data-submenu-active="true"`
            // here keeps the invisible submenu content intercepting clicks on
            // the page after the menu is closed. Reset it so the base
            // `opacity-0 translate-x-full` (and default pointer-events that
            // inherits `none` from the parent) take over.
            overlayContainer.dataset.submenuActive = 'false';
          }
        });
      },
      goBack: function () {
        this.$refs.overlayContainer.dataset.submenuActive = 'false';
      },
    };
  };
  } catch(e) { console.error(e); }
})();

})();
